export class MapUtils {
  static debounce(callback, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => callback(...args), delay);
    };
  }

  static hashNode(node) {
    return `${node.lat},${node.lon},${JSON.stringify(node.tags || {})}`;
  }
}
